import React from 'react';
import styled from 'styled-components';
import { TimePickerMenu } from './TimePickerMenu.js';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/assertThisInitialized';
import '@babel/runtime/helpers/esm/inherits';
import '@babel/runtime/helpers/esm/possibleConstructorReturn';
import '@babel/runtime/helpers/esm/getPrototypeOf';
import '@babel/runtime/helpers/esm/defineProperty';
import 'prop-types';
import '@elliemae/ds-utilities/utils';
import '@elliemae/ds-classnames';
import 'moment';
import '@elliemae/ds-utilities/timeUtils';
import './utils.js';
import './PickerPanel.js';
import '@babel/runtime/helpers/esm/extends';
import '@babel/runtime/helpers/esm/slicedToArray';
import '@babel/runtime/helpers/esm/toArray';
import 'lodash';
import 'memoize-one';
import '@elliemae/ds-icons/ChevronSmallUp';
import '@elliemae/ds-icons/ChevronSmallDown';
import '@elliemae/ds-button';
import './moveElementOnScroll.js';

var DSTimePickerMenuWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1lnruj5-0"
})(["display:flex;height:18.6rem;"]);

function DSTimePickerMenu(props) {
  return /*#__PURE__*/React.createElement(DSTimePickerMenuWrapper, null, /*#__PURE__*/React.createElement(TimePickerMenu, props));
}

export default DSTimePickerMenu;
export { DSTimePickerMenu };
//# sourceMappingURL=DSTimePickerMenu.js.map
